import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-people-of-interest.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-people-of-interest.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { ApplicationCreateService } from "../shared/application-create.service";
import { AflaModuleStrategyService } from "../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../app-controller.service";
import { SelectedApplicationService } from "../../shared/services/selected-application/selected-application.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SearchApplicationsService } from "../../search-applications/shared/search-applications.service";
import { SharedConstants } from "../../shared/constants/shared.constants";
import { AlertType } from "../../shared/models/alert";
import { CreateApplicationViewBaseComponent } from "../shared/create-application-view-base/create-application-view-base.component";
import { CreateApplicationPeopleOfInterestConstants } from "./create-application-people-of-interest.constants";
let CreateApplicationPeopleOfInterestComponent = class CreateApplicationPeopleOfInterestComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    appController;
    selectedApplicationService;
    modalService;
    changeDetectorRefs;
    searchApplicationsService;
    peopleOfInterestForm;
    transferorFormControlName = CreateApplicationPeopleOfInterestConstants.TRANSFEROR_FORM_CONTROL_NAME;
    transfereeFormControlName = CreateApplicationPeopleOfInterestConstants.TRANSFEREE_FORM_CONTROL_NAME;
    conveyancerFormControlName = CreateApplicationPeopleOfInterestConstants.CONVEYANCER_FORM_CONTROL_NAME;
    transferorDisableFilterBy = true;
    transferorDisableEditing = false;
    transferorGroups = [];
    transferorLabel = CreateApplicationPeopleOfInterestConstants.TRANSFEROR_LABEL;
    transfereeDisableFilterBy = true;
    transfereeDisableEditing = false;
    transfereeGroups = [];
    transfereeLabel = CreateApplicationPeopleOfInterestConstants.TRANSFEREE_LABEL;
    copyApplicantToTransfereeLabel = CreateApplicationPeopleOfInterestConstants.COPY_APPLICANT_TO_TRANSFEREE_LABEL;
    conveyancerDisableFilterBy = true;
    conveyancerDisableEditing = false;
    conveyancerGroups = [];
    conveyancerLabel = CreateApplicationPeopleOfInterestConstants.CONVEYANCER_LABEL;
    copyApplicantToTransfereeFormControlName = CreateApplicationPeopleOfInterestConstants.COPY_APPLICANT_TO_TRANSFEREE_FORM_CONTROL_NAME;
    savedApplicant;
    constructor(createApplicationService, aflaModuleStrategyService, appController, selectedApplicationService, modalService, changeDetectorRefs, searchApplicationsService) {
        super(createApplicationService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.selectedApplicationService = selectedApplicationService;
        this.modalService = modalService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.searchApplicationsService = searchApplicationsService;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        if (this.isApplicationLoadedFromTheSearchPage) {
            // application loaded from the search page.
            this.checkApplicationData();
        }
        this.subScribeToSelectedApplication();
    }
    loadMetadata(stepMeta) {
        try {
            this.transferorGroups = stepMeta.transferorGroup;
            this.transfereeGroups = stepMeta.transfereeGroup;
            this.conveyancerGroups = stepMeta.conveyancerGroup;
            this.changeDetectorRefs.markForCheck();
        }
        catch (e) {
            this.appController.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    initForm() {
        this.peopleOfInterestForm = this.aflaModuleStrategyService.form.get("peopleOfInterestForm");
        this.changeDetectorRefs.detectChanges();
    }
    onBtnCopyApplicantToTransfereeClicked(event) {
        const transfereeFormControl = this.peopleOfInterestForm.get("transferee");
        if (event.currentTarget.checked === true) {
            const transfereeFormControl = this.peopleOfInterestForm.get(this.transfereeFormControlName);
            transfereeFormControl.clearValidators();
            this.peopleOfInterestForm.get(this.copyApplicantToTransfereeFormControlName).setValue(true);
            const transfereeGroups = Object.assign({}, this.transfereeGroups[0]);
            const transferee = this.savedApplicant;
            transferee.groups = transfereeGroups[0];
            this.peopleOfInterestForm.get(this.transfereeFormControlName).setValue(transferee);
            transfereeFormControl.disable();
            this.changeDetectorRefs.detectChanges();
        }
        else {
            transfereeFormControl.enable();
            transfereeFormControl.reset();
            this.peopleOfInterestForm.get(this.copyApplicantToTransfereeFormControlName).setValue(false);
            this.getMetadata();
            this.changeDetectorRefs.detectChanges();
        }
    }
    checkApplicationData() {
        const isFormPristine = this.peopleOfInterestForm.pristine;
        const isFormUnTouched = this.peopleOfInterestForm.untouched;
        const isFormInvalid = this.peopleOfInterestForm.invalid;
        if (isFormPristine && isFormUnTouched && isFormInvalid) {
            this.onGetApplicationDataCompleted(this.selectedApplication);
        }
    }
    onGetApplicationDataCompleted(selectedApplication) {
        let transferee;
        const transfereeFormControl = this.peopleOfInterestForm.get("transferee");
        transferee = selectedApplication.transferee[0];
        if (transferee) {
            transfereeFormControl.setValue(transferee);
        }
        let transferor;
        const transferorFormControl = this.peopleOfInterestForm.get("transferor");
        transferor = selectedApplication.transferor[0];
        if (transferor) {
            transferorFormControl.setValue(transferor);
        }
        let conveyancer;
        const conveyancerFormControl = this.peopleOfInterestForm.get("conveyancer");
        conveyancer = selectedApplication.conveyancer[0];
        if (conveyancer) {
            conveyancerFormControl.setValue(conveyancer);
        }
    }
    subScribeToSelectedApplication() {
        this.selectedApplicationService.$selectedApplication.subscribe({
            next: (application) => {
                if (application && application.applicant && application.applicant.length > 0) {
                    this.savedApplicant = application.applicant[0];
                }
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: SelectedApplicationService },
        { type: NgbModal },
        { type: ChangeDetectorRef },
        { type: SearchApplicationsService }
    ];
};
CreateApplicationPeopleOfInterestComponent = __decorate([
    Component({
        selector: "app-create-application-people-of-interest",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationPeopleOfInterestComponent);
export { CreateApplicationPeopleOfInterestComponent };
